import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/crae',
  component: Layout,
  name: 'Crae',
  meta: {
    title: 'CRAE管理',
    icon: 'i-ant-design:robot-outlined',
    auth: [],
  },
  children: [
    {
      path: 'error-report/index',
      name: 'CraeErrorReportIndex',
      component: () => import('@/views/crae/error-report/index.vue'),
      meta: { title: '错误报告', icon: 'i-ant-design:alert-outlined', auth: 'crae:error-report:list' },
    },
    {
      path: 'tenant/index',
      name: 'CraeTenantIndex',
      component: () => import('@/views/crae/tenant/index.vue'),
      meta: {
        title: '租户配置',
        icon: 'i-ant-design:team-outlined',
        auth: 'crae:robot:list',
      },
    },
    {
      path: 'robot/index',
      name: 'CraeRobotIndex',
      component: () => import('@/views/crae/robot/index.vue'),
      meta: {
        title: '机器人列表',
        icon: 'i-ant-design:robot-outlined',
        auth: 'crae:robot:list',
      },
    },
    {
      path: 'room/index',
      name: 'CraeRoomIndex',
      component: () => import('@/views/crae/room/index.vue'),
      meta: {
        title: '房间列表',
        icon: 'i-ant-design:appstore-outlined',
        auth: 'crae:robot:list',
      },
    },
    {
      path: 'app-update/index',
      name: 'CraeAppUpdateIndex',
      component: () => import('@/views/crae/app-update/index.vue'),
      meta: {
        title: '版本管理',
        icon: 'i-ant-design:mobile-outlined',
        auth: 'crae:app-update:list',
      },
    },
    {
      path: 'send-record/index',
      name: 'CraeSendRecordIndex',
      component: () => import('@/views/crae-message/send-record/index.vue'),
      meta: {
        title: '发送记录',
        icon: 'i-ant-design:send-outlined',
        auth: 'crae:send-record:list',
      },
    },
    {
      path: 'agreement/index',
      name: 'CraeAgreementIndex',
      component: () => import('@/views/crae/agreement/index.vue'),
      meta: {
        title: '用户协议',
        icon: 'i-ant-design:safety-certificate-outlined',
        auth: 'crae:agreement:list',
      },
    },
    {
      path: 'message-send',
      name: 'CraeMessageSend',
      component: () => import('@/views/crae-message/send/index.vue'),
      meta: {
        title: '发送',
        icon: 'i-ant-design:message-outlined',
        auth: 'crae:message:send',
      },
    },
    {
      path: 'message-receive',
      name: 'CraeMessageReceive',
      component: () => import('@/views/crae-message/receive/index.vue'),
      meta: {
        title: '接收返回',
        icon: 'i-ant-design:inbox-outlined',
      },
    },
  ],
}

export default routes
